// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "label-3-96P";
var _3 = "radio-2He06";
var _4 = "active-1PfAp";
export { _1 as "__esModule", _2 as "label", _3 as "radio", _4 as "active" }
export default { "__esModule": _1, "label": _2, "radio": _3, "active": _4 }
